// extracted by mini-css-extract-plugin
export default {"container":"reset_container__hwIGL","title":"reset_title__ZDcu0","form":"reset_form__PkHPS","card":"reset_card__Vr4e2"};